import React from 'react';
import './heroSlider.css';

import { Container } from 'reactstrap';
import Slider from 'react-slick';
import { sliderData } from '../../assets/fake-data/slider';

const HeroSlider = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 3000,
    };

    return (
        <section className="heroSlider">
            <Container>
                <Slider {...settings}>
                    {sliderData.map((item) => (
                        <div
                            key={item.id}
                            className="slider__wrapper d-flex align-items-center justify-content-between pt-5"
                        >
                            <div className="slider__content  ps-2">
                                <h2 className="mb-3">{item.title}</h2>
                                <p>{item.desc}</p>
                                <button className="btn">Explore food</button>
                            </div>

                            <div className="slider__img ">
                                <img src={item.imgUrl} alt={item.title} className="w-100" />
                            </div>
                        </div>
                    ))}
                </Slider>
            </Container>
        </section>
    );
};

export default HeroSlider;
